import { render } from "./CollectionProductsFilter.vue?vue&type=template&id=4822bf9f"
import script from "./CollectionProductsFilter.vue?vue&type=script&lang=js"
export * from "./CollectionProductsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__